module.exports = ".button_container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.scss
// module id = ./src/app/admin/admin.component.scss
// module chunks = main